import { components } from 'react-select'
import styled, { css } from 'styled-components'
import { margin, MarginProps } from 'styled-system'

import Icon from 'components/Icon'
import Text from 'components/Text'

import { FixMeAny } from 'types/global'
import { WidthProps } from 'types/styled'
import { ThemeColor } from 'utils/colors'

import { AddonStyleProps } from './types'
import Box from 'components/Box'

export const RequiredText = styled.span`
  color: ${(p) => p.theme.colors.red};
  margin-left: 4px;
`

export const OptionContainer = styled.div`
  background: ${(p) => p.theme.colors.white};
  border-bottom: 1px solid ${(p) => p.theme.colors.gray3};
  cursor: pointer;
  text-align: left;
`

export const ActionOptionContainer = styled.div<{ indention?: 0 | 1 | 2 }>`
  padding-left: ${(p) => (p?.indention || 0) * 16}px;
`

export const NormalOptionContainer = styled(OptionContainer)<{
  isDisabled?: boolean
}>`
  display: flex;
  align-items: center;
  opacity: ${(p) => (p.isDisabled ? '0.5;' : '1')};
  outline: 0 solid transparent;

  & > .option-with-avatar {
    padding: 0 12px 0 16px;
  }
`

export const MultiOptionContainer = styled(OptionContainer)<{
  isDisabled?: boolean
  isFocused?: boolean
  isSelected?: boolean
}>`
  background: ${(p) =>
    p.isSelected ? p.theme.colors.blue5 : p.isFocused ? p.theme.colors.gray2 : p.theme.colors.white};
  opacity: ${(p) => (p.isDisabled ? '0.5;' : '1')};
`

export const StyledIcon = styled((p) => <Icon {...p} />)<{ indention?: 0 | 1 | 2 }>`
  margin: 14px 7px 14px ${(p) => p.indention || 1 * 16}px;
  vertical-align: bottom;
`

export const StyledControl = styled(components.Control)<{ hasValue?: boolean; containerColor?: ThemeColor }>`
  cursor: pointer !important;
  background-color: ${(p) => p.hasValue && (p.containerColor ? `${p.containerColor} !important` : 'inherit')};

  .react-select__multi-value {
    padding: 5px;
  }
`

export const StyledOption = styled((p) => <components.Option {...p} />)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${({ isFixedWoIcon }) =>
    isFixedWoIcon &&
    css`
      position: sticky;
      bottom: 0;
      left: 0;
      height: 40px;
      padding: 8px 16px !important;
    `}
`

export const StyledOptionWithAvatar = styled(StyledOption)`
  display: flex;
  align-items: center;

  & > div:first-of-type {
    margin-right: 5px;
  }

  & > div:last-of-type {
    text-transform: capitalize;
  }
`

// TODO: Fix typings
export const StyledInput = styled((p) => <components.Input {...p} />)<FixMeAny>`
  > input {
    -webkit-font-smoothing: antialiased !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: ${(p) => p.theme.colors.gray7} !important;
  }
`

export const AvatarContainer = styled.div`
  margin: 0 8px 0 4px;
`

export const OptionLabel = styled(Text)`
  padding: 16px 16px 16px 7px;
  text-transform: capitalize;
`

export const MultiValueContainer = styled.div<{ disabled?: boolean }>`
  ${(p) => p.theme.font({ color: p.disabled ? 'disabledText' : 'defaultText' })}
  border-right: 1px solid ${(p) => (p.disabled ? p.theme.colors.disabledText : p.theme.colors.defaultText)};
  padding: 0 4px;
`

export const LabelText = styled(Text)<{ disabled?: boolean }>`
  ${(p) => p.theme.font({ color: p.disabled ? 'gray4' : 'defaultText' })}
  margin-bottom: 6px;
`

export const DropdownContainer = styled.div<
  MarginProps & AddonStyleProps & { disabled?: boolean; width: WidthProps; isEditClicked?: boolean }
>`
  ${margin}
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${({ theme, isEditClicked }) => isEditClicked && `border-bottom: 1px solid ${theme.colors.gray3}`};
  width: ${(p) =>
    p.width === 'auto' ? (p.inline ? '250px' : '100%') : `${typeof p.width === 'string' ? p.width : `${p.width}px`}`};
`

export const EditBox = styled(Box)`
  transform: translateY(-50%);
`
